// extracted by mini-css-extract-plugin
export default {"tileButtonShadow":"tile-button-shadow___c6DKQIO"};